// Çalışan Finans Yönetimi (/employee-finance-management) ve pencereleri:
// Maaş Bilgileri, Ödeme Geçmişi, Çalışan Bütçe Ücretlendirme, Toplu Zam.
// Kayıtlı değerler (ödeme türü, eğitim bilgisi, gider adları) ve Excel aynı kalır.
const employeeFinance = {
  page: {
    title: 'Çalışan Finans Yönetimi',
    subtitle: 'Çalışanların maaş kayıtları, ödemeleri, proje bazlı bütçe ücretlendirmesi ve toplu zam.',
  },
  actions: {
    excel: 'Tabloyu İndir',
    excelHint: 'Çalışan listesini Excel olarak indir',
    raise: 'Toplu Zam',
    raiseHint: 'Seçilen çalışanlara yüzde ile zam uygula',
  },
  stats: {
    total: 'Toplam Çalışan',
    totalShort: 'Toplam',
    active: 'Aktif Çalışan',
    activeShort: 'Aktif',
    inactive: 'İnaktif Çalışan',
    inactiveShort: 'İnaktif',
    share: 'Çalışanların %{{percent}}’i',
  },
  toolbar: {
    search: 'İsim, soyisim veya TC no ile ara…',
    searchShort: 'Çalışan ara…',
    status: 'Durum',
    status_1: 'Aktif',
    status_0: 'İnaktif',
    status_all: 'Tümü',
  },
  status: {
    active: 'Aktif',
    inactive: 'İnaktif',
  },
  yesNo: {
    yes: 'Evet',
    no: 'Hayır',
  },
  turkey: 'Türkiye',
  workTypes: {
    fullTime: 'Tam Zamanlı',
    partTime: 'Yarı Zamanlı',
  },
  columns: {
    eName: 'Ad',
    eSurname: 'Soyad',
    tcNumber: 'TC No',
    phone: 'Telefon',
    departman: 'Departman',
    Active: 'Durum',
    eMail: 'E-posta',
    startDate: 'Başlangıç Tarihi',
    workType: 'Çalışma Şekli',
    address: 'Ev Adresi',
    annualPermit: 'Yıllık İzin',
    birthday: 'Doğum Tarihi',
    isHandicappedPerson: 'Engellilik Durumu',
    isIntern: 'Stajyer',
    isRetired: 'Emekli',
    languageInfo: 'Dil Bilgisi',
    nationality: 'Uyruk',
    profession: 'Meslek',
    educationInfo: 'Eğitim Bilgisi',
  },
  table: {
    listLabel: 'Çalışanlar',
    empty: 'Filtrelere uygun çalışan bulunamadı',
    rangeOf: '/ {{total}} çalışan',
    ofTotal: 'toplam {{total}} çalışan içinden',
    jump: 'Sayfaya git',
  },
  panel: {
    label: 'Seçili çalışan',
    heading: 'Çalışan',
    salary: 'Maaş',
    payments: 'Ödemeler',
    budgetPricing: 'Bütçe Ücretlendirme',
  },
  common: {
    cancel: 'İptal',
    close: 'Kapat',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    update: 'Güncelle',
    clear: 'Temizle',
    choose: 'Lütfen seçiniz',
    loading: 'Yükleniyor…',
  },
  salaries: {
    title: 'Maaş Bilgileri',
    add: 'Yeni Maaş Ekle',
    note: 'En yeni kayıt güncel maaştır; Maaş Ödemeleri bu kaydı kullanır. Kesintiler brüt ücretten sabit oranlarla hesaplanır.',
    loading: 'Maaş bilgileri yükleniyor…',
    empty: 'Bu çalışana ait herhangi bir maaş kaydı bulunmamaktadır.',
    current: 'Güncel',
    actions: 'İşlemler',
    edit: 'Maaş kaydını düzenle',
    delete: 'Sil',
    deleteTitle: 'Maaş kaydı silinsin mi?',
    deleteMessage: '{{date}} tarihli maaş kaydı kalıcı olarak silinecek.',
    deleted: 'Maaş kaydı başarıyla silindi',
    deleteError: 'Maaş kaydı silinirken bir hata oluştu',
    loadError: 'Maaş bilgileri alınırken bir hata oluştu',
    columns: {
      contractDate: 'Sözleşme Tarihi',
      grossSalary: 'Brüt Ücret',
      sskEmployeeShare: 'SGK İşçi Payı (%14)',
      unemploymentEmployeeShare: 'İşsizlik Sig. İşçi Payı (%1)',
      stampTax: 'Damga Vergisi',
      totalDeductions: 'Kesintiler Toplamı',
      netSalary: 'Net Ücret',
      sskEmployerShare: 'SGK İşveren Payı (%15.5)',
      unemploymentEmployerShare: 'İşsizlik Sig. İşveren Payı (%2)',
      totalEmployerCost: 'Toplam Maliyet',
    },
  },
  salaryForm: {
    newTitle: 'Yeni Maaş Ekle',
    editTitle: 'Maaş Bilgisini Düzenle',
    subtitle: 'Net ücret girilir; brüt ücret ve maliyet hesaplanır.',
    contractDate: 'Sözleşme Tarihi',
    net: 'Net Ücret (₺)',
    netHint: 'Çalışanın eline geçecek net tutar',
    result: 'Hesaplanan',
    gross: 'Brüt Ücret',
    deductions: 'Kesintiler Toplamı',
    cost: 'Toplam İşveren Maliyeti',
    empty: 'Net ücreti girdiğinizde brüt ücret, kesintiler ve işveren maliyeti burada görünür.',
    required: 'Lütfen tüm zorunlu alanları doldurun!',
    added: 'Maaş bilgisi başarıyla eklendi!',
    updated: 'Maaş bilgisi başarıyla güncellendi!',
    error: 'Maaş işlenirken bir hata oluştu!',
  },
  payments: {
    title: 'Ödeme Geçmişi',
    add: 'Yeni Ödeme Ekle',
    loading: 'Ödemeler yükleniyor…',
    empty: 'Bu çalışana ait herhangi bir ödeme kaydı bulunamadı.',
    total: '{{count}} ödeme · toplam',
    salaryType: 'Maaş Ödemesi',
    otherType: 'Diğer Ödeme',
    salaryDescription: '{{period}} dönemi maaş ödemesi',
    paid: 'Ödendi',
    columns: {
      date: 'Ödeme Tarihi',
      type: 'Ödeme Türü',
      amount: 'Tutar',
      description: 'Açıklama',
      status: 'Durum',
    },
  },
  paymentTypes: {
    Avans: 'Avans',
    Prim: 'Prim',
    'Harcırah': 'Harcırah',
    'Yol-Yemek': 'Yol-Yemek',
    'Diğer': 'Diğer',
  },
  paymentForm: {
    title: 'Ödeme Ekle',
    noProjects: 'Bu çalışan henüz hiçbir projede yer almıyor. Ödeme eklemek için önce çalışanı bir projeye atamanız gerekir.',
    project: 'Proje',
    projectPlaceholder: 'Lütfen proje seçiniz',
    type: 'Ödeme Türü',
    date: 'Ödeme Tarihi',
    amount: 'Ödenen Miktar (₺)',
    reason: 'Ödeme Gerekçesi',
    reasonPlaceholder: 'Ödeme açıklaması…',
    submit: 'Ödeme Ekle',
    required: 'Lütfen zorunlu alanları doldurun',
    added: 'Ödeme başarıyla eklendi',
    error: 'Ödeme eklenirken bir hata oluştu',
    projectsError: 'Projeler yüklenirken bir hata oluştu',
  },
  pricing: {
    title: 'Çalışan Bütçe Ücretlendirme',
    note: 'Çalışanın atandığı her proje için ziyaret ücretlerini girin. Kaydettiğinizde girilen her ücret için projeye bir gider kaydı (Beklemede) oluşturulur.',
    untitled: 'İsimsiz Proje',
    types: {
      shortVisit: 'Short Visit',
      fullVisit: 'Full Visit',
      other: 'Diğer',
    },
    remove: 'Kaldır',
    titleLabel: 'Başlık',
    titlePlaceholder: 'Başlık giriniz (örn: Telefon Görüşmesi)',
    amountLabel: '{{type}} ücreti',
    noProjects: 'Bu çalışanın atandığı proje bulunmamaktadır',
    notFound: 'Çalışan bilgileri bulunamadı',
    noEmployee: 'Çalışan bilgisi bulunamadı',
    loadError: 'Çalışan bilgileri yüklenirken bir hata oluştu',
    saved: 'Bütçe ücretlendirme bilgileri başarıyla kaydedildi',
    savedWithExpenses: 'Bütçe ücretlendirme bilgileri kaydedildi ve {{count}} gider kaydı oluşturuldu',
    saveError: 'Kaydetme sırasında bir hata oluştu',
  },
  raise: {
    title: 'Toplu Maaş Zammı',
    subtitle: 'Maaş kaydı olan aktif çalışanlar',
    percent: 'Zam Yüzdesi',
    percentPlaceholder: 'Örn: 10',
    summary: 'Özet',
    selected: 'Seçili',
    currentTotal: 'Mevcut net toplam',
    newTotal: 'Yeni net toplam',
    monthlyDifference: 'Aylık net fark: +{{amount}}',
    search: 'Çalışan veya departman ara…',
    selectAll: 'Tümünü Seç',
    deselectAll: 'Tümünü Kaldır',
    empty: 'Maaş bilgisi olan aktif çalışan bulunamadı.',
    noMatch: 'Aramaya uyan çalışan yok.',
    columns: {
      employee: 'Çalışan',
      department: 'Departman',
      current: 'Mevcut Net Maaş',
      next: 'Yeni Net Maaş',
      difference: 'Fark',
    },
    apply: 'Zammı Uygula',
    confirmTitle: 'Zam uygulansın mı?',
    confirmMessage: '{{count}} çalışan için %{{percent}} zam uygulamak istediğinize emin misiniz? Her çalışan için bugünün tarihiyle yeni bir maaş kaydı oluşturulur.',
    noneSelected: 'Lütfen en az bir çalışan seçin!',
    invalidPercent: 'Lütfen geçerli bir zam yüzdesi girin!',
    applied: '{{count}} çalışan için zam başarıyla uygulandı!',
    error: 'Zam uygulanırken bir hata oluştu!',
    loadError: 'Çalışanlar yüklenirken bir hata oluştu',
  },
  toast: {
    loadError: 'Çalışanlar yüklenirken hata oluştu',
    excelDone: 'Excel dosyası başarıyla indirildi',
    excelError: 'Dosya indirilirken hata oluştu',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default employeeFinance;
